import { Col, DatePicker, Form, Input, Row } from "antd";
import { FormItemHiddenUi, PersonaDocumentoSearchInput } from "../../ui";
import { TipoDocumentoSelect } from "../../configuraciones/TipoDocumentoSelect";
import {
  DateFormats,
  TipoDocumentoPersonaConstants,
} from "../../../types/typesConstants";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { AdicionalesProveedor } from "./AdicionalesProveedor";
import { UbicacionProveedor } from "./UbicacionProveedor";

export const ProveedorForm = () => {
  const form = Form.useFormInstance();
  const tipodocumento = Form.useWatch(["persona", "tipodocumento"], form);
  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={24} lg={16} xl={17}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
              <Form.Item
                label="Tipo Documento"
                name={["persona", "tipodocumento"]}
                rules={[
                  {
                    required: true,
                    message: "El tipo de documento es obligatorio",
                  },
                ]}
              >
                <TipoDocumentoSelect placeholder="[-Seleccione-]" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <Form.Item
                label="N° Documento"
                name={["persona", "nrodocumento"]}
                rules={[
                  {
                    required: true,
                    message: "El número de documento es obligatorio",
                  },
                ]}
              >
                <PersonaDocumentoSearchInput
                  tipodocumento={tipodocumento}
                  placeholder="Ingrese el número de documento"
                />
              </Form.Item>
            </Col>
          </Row>
          {tipodocumento === TipoDocumentoPersonaConstants.Ruc && (
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <Form.Item
                  name={["persona", "nombrecompleto"]}
                  label="Razón Social"
                >
                  <Input placeholder="Razón social" />
                </Form.Item>
              </Col>
            </Row>
          )}
          {tipodocumento !== TipoDocumentoPersonaConstants.Ruc && (
            <>
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={24} md={16} lg={12} xl={12}>
                  <Form.Item
                    name={["persona", "nombres"]}
                    label="Nombre"
                    rules={[
                      {
                        required: true,
                        message: "Los nombres son obligatorios",
                      },
                    ]}
                  >
                    <Input placeholder="Ingrese nombre" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Apellido paterno"
                    name={["persona", "apepaterno"]}
                    rules={[
                      {
                        required: true,
                        message: "El apellido paterno es obligatorio",
                      },
                    ]}
                  >
                    <Input placeholder="Ingrese apellido paterno" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 24]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Apellido materno"
                    name={["persona", "apematerno"]}
                    rules={[
                      {
                        required: true,
                        message: "El apellido materno es obligatorio",
                      },
                    ]}
                  >
                    <Input placeholder="Ingrese apellido materno" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={16} lg={6} xl={4}>
                  <Form.Item
                    name={["persona", "fechanacimiento"]}
                    label="Fecha nacimiento"
                    rules={[
                      {
                        required: true,
                        message: "La fecha de nacimiento es obligatorio",
                      },
                    ]}
                  >
                    <DatePicker
                      format={DateFormats.frontend}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={6}>
              <Form.Item name={["persona", "telefono"]} label="Telefono">
                <Input
                  placeholder="Ingrese telefono"
                  addonBefore={<PhoneOutlined />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
              <Form.Item
                name={["persona", "email"]}
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "El email es incorrecto",
                  },
                ]}
              >
                <Input
                  placeholder="Ingrese correo electrónico"
                  addonBefore={<MailOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
          <UbicacionProveedor />
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={7}>
          <Row>
            <Col span={24}>
              <AdicionalesProveedor />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
